import React from 'react';
import { Animation } from '@catalogo/theme-animation';
import { Content, Title, Hr, Exit } from './Styled';
import { IModalSheet } from '../../../types';

const ModalSheet = ({ children, visible, title, exitFunc }: IModalSheet) => (
  <Animation type="slide" direction="top" visible={visible} background={true}>
    <Content>
      <Exit onClick={exitFunc}>
        <Hr />
      </Exit>
      <Title>{title}</Title>
      {children}
    </Content>
  </Animation>
);

export default ModalSheet;
export { ModalSheet };
